<template>
  <div class="product-main">
    <div class="banner" v-if="deviceType == 'pc'"><div class="w"></div></div>
    <img src="../../assets/images/home/cpyfa.png" alt="" v-else />
    <div class="w">
      <div class="local">
        产品与方案：
        <a
          v-for="(item, i) in articleList"
          :key="i"
          :class="typeActive === item.categoryId ? 'active' : ''"
          @click="clickType(item)"
          >{{ item.title }}</a
        >
      </div>
    </div>
    <div class="latest-product">
      <div class="w">
        <div class="title">最新产品</div>
        <div class="product w1200">
          <div class="content">
            <ul class="productUL">
              <li
                @click="openLink(`/product/detail?id=${item.id}`)"
                v-for="(item, index) in parentList"
                :key="index"
              >
                <a :title="item.title" class="product-item">
                  <div class="cover-image-box">
                    <!-- coverImage -->
                    <img
                      class="cover-image"
                      :src="
                        item.coverImage ||
                        require('@/assets/images/product-latest3.png')
                      "
                    />
                  </div>
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">
                    {{ item.description }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="government-products w">
      <div class="series-title">{{ typeActiveText }}</div>
      <ul class="gov-pro-list">
        <li
          v-for="(item, index) in articleData"
          :key="index"
          @click="openLink(`/product/detail?id=${item.id}`)"
        >
          <a :title="item.title" class="item">
            <div class="icon-box">
              <!-- coverImage -->
              <img
                class="icon"
                :src="
                  item.icon || require('@/assets/images/product-gov-jggl.gif')
                "
              />
            </div>
            <img
              class="iconProductHover"
              :src="
                item.icon || require('@/assets/images/product-gov-jggl.gif')
              "
              style="display: none"
            />
            <div class="title">{{ item.title }}</div>
            <div class="brief-intro">
              {{ item.description }}
            </div>
            <div
              class="introduce"
              v-html="
                item.content
                  ? item.content
                      .replace(/<[^<>]+>/g, '')
                      .replace(/&nbsp;/gi, '')
                  : ''
              "
            ></div>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <div class="pagination_box">
        <el-pagination
          background
          @current-change="currentChange"
          layout="prev, pager, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
        >
        </el-pagination>
      </div>
    </div>
    <blockSidebar />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/product.scss`
)
import blockSidebar from '@/components/block-sidebar'
export default {
  // 产品
  components: { blockSidebar },
  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 6,
        total: 0,
      },
      typeActive: '10',
      typeActiveText: '全部',
      articleData: [],
      articleList: [],
      parentList: [],
    }
  },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  mounted() {
    this.getArticlePage()
    this.getArticleList()
    this.getParentList()
  },
  methods: {
    getArticlePage() {
      const params = {
        categoryId: this.typeActive,
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      }
      this.$api.product.getArticlePage(params).then((res) => {
        if (res.code === 200) {
          this.articleData = res.rows
          this.queryParam.total = res.total
        }
      })
    },
    getArticleList() {
      this.$api.common.getArticleList(10).then((res) => {
        if (res.code === 200) {
          this.articleList = res.data
          this.articleList.unshift({ title: '全部', categoryId: '10' })
        }
      })
    },
    getParentList() {
      const params = {
        categoryId: this.typeActive,
      }
      this.$api.product.getParentList(params).then((res) => {
        if (res.code === 200) {
          this.parentList = res.rows
        }
      })
    },
    currentChange(v) {
      this.queryParam.pageNum = v
      this.getArticlePage()
    },
    clickType(v) {
      this.typeActive = v.categoryId
      this.typeActiveText = v.title
      this.queryParam.pageNum = 1
      this.getArticlePage()
      this.getParentList()
    },
    openLink(path) {
      this.$router.push(path)
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  background: url(~@/assets/images/home/banner-product.gif) no-repeat center;
}
</style>
